<div class="multi-debug">
  <app-debug-trip *ngFor="let i of count"></app-debug-trip>
  <button (click)="addView()">+</button>
</div>
